module.exports = __webpack_public_path__ + "assets/img/media_3.64ec52b6.png";